<template>
    <modal name="main-modal" transition="pop-out" height="auto" :scrollable="true"
           width="80%"
           :adaptive="true">
        <div class="agree-modal">
            <common-header left-div="blank" right-div="close" v-on:closeEvent="closeModal" />

            <div class="content">
                <img src="https://ba8hb5guu4.ecn.cdn.ofs.kr/images/app/main/renewal-2021-09-30/main_popup.png?t=2021100101">
                <div class="ion-text-center pb-2 close_one_day" v-on:click="hideOneDay">
                    <input type="checkbox" id="close_one_day" class="css-checkbox"/><label for="close_one_day" name="close_one_day" class="css-label lite-orange-check">오늘 하루 안보기</label>
                </div>
                <div>
                    <button class="purchase-button" v-on:click="agreeClickEvent">이용권 구매하기</button>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
import CommonHeader from "../../components/header/CommonHeader";
import FooterOneButtonbar from "../../components/footer/FooterOneButtonbar";

export default {
    name: 'MainPopupModal',
    components: {CommonHeader, FooterOneButtonbar},
    props: [],
    data() {
        return {
        }
    },
    methods: {
        closeModal() {
            this.$modal.hide('main-modal');
        },
        hideOneDay() {
            this.$cookie.set("mainPopupShouldHide", true, 1);
            var currentTimeStamp = Math.floor(Date.now() / 1000);
            this.$cookie.set("mainPopupLastShown", currentTimeStamp, 1);

            this.$modal.hide('main-modal');
        },
        agreeClickEvent() {
            this.$modal.hide('main-modal');
            this.$router.push('/mypage/ticket');
        }
    }
}
</script>

<style scoped lang="scss">
.agree-modal {
    padding: 1em 0;

    .header-toolbar{
        height: 40px;
    }

    div.title {
        font-weight: $font-weight500;
    }

    div.content {
        background-color: white;

        img {
            display: block;
            margin: 0 auto;
        }

        .close_one_day {
            font-size: $font-base13;
            font-weight: 500;
        }

        .purchase-button {
            color: white;
            background: $primary-color;
            width: 100%;
            height: 50px;
            font-size: $font-base14;
        }
    }
}
</style>
